export default __webpack_public_path__ + "static/media/cityEn.cd1a28c4.png";